export default {
  path: '/wecode/weVote-fill',
  auth: false,
  preload: false,
  key: 'weVote',
  component: () => import('./index')
};
